// Goals and collected amounts come from the caisse's native association,
// independently of the currency interface used to make a new donation.
export function caisseCurrency(caisse, org) {
    return org?.cerfasInfos?.find(assoc => assoc.id === (caisse?.assoc || 'MAIN'))?.devise
        || org?.orgDevise || org?.devise || 'eur';
}
